
import { PeelingSamples } from "../entities/peeling-samples.entity";
import { Peeling } from "../entities/peeling.entity";
import { PeelingSamplesDto } from "./pelling-samples.dto";
import { PeelingDto } from "./peeling.dto";

export class PeelingAdapter {
    public convertDtoToEntity(dto: PeelingDto): Peeling {
        console.log("test",dto)
        try {
            const entity = new Peeling;
            entity.saleOrderId = dto.saleOrderId
            entity.saleOrderItemId = dto.saleOrderItemId
            entity.lotNumber = dto.lotNumber
            entity.peelingDate = dto.peelingDate
            entity.shift = dto.shift
            entity.isActive = dto?.isActive || true;
            if (dto?.peelingId) {
                entity.peelingId = dto.peelingId;
                entity.updatedUser = dto.updatedUser;
            } else {
                entity.createdUser = dto.createdUser;
            }
            const peelingSamplesInfo: PeelingSamples[] = [];

            for (const sampleDto of dto.peelingSamplesInfo) {
                const peelingSample = new PeelingSamples();
                peelingSample.peelingId = dto?.peelingId;
                peelingSample.sampleNo = sampleDto?.sampleNo;
                peelingSample.temperature = sampleDto?.temperature;
                peelingSample.count = sampleDto?.count;
                peelingSample.typeOfCut = sampleDto?.typeOfCut;
                peelingSample.bigToSmallRatio = sampleDto.bigToSmallRatio;
                peelingSample.legsVeinsShell = sampleDto.legsVeinsShell;
                peelingSample.improperCutting = sampleDto.improperCutting;
                peelingSample.blackTailBlackSpot = sampleDto.blackTailBlackSpot;
                peelingSample.brokenUnstable = sampleDto.brokenUnstable;
                peelingSample.deteriorationDecomposition = sampleDto.deteriorationDecomposition;
                peelingSample.otherObjectionableDefects = sampleDto.otherObjectionableDefects;
                peelingSample.checkedBy = sampleDto.checkedBy;
                peelingSample.remarks = sampleDto?.remarks;

                if (sampleDto?.peelingSamplesId) {
                    peelingSample.peelingSamplesId = sampleDto.peelingSamplesId;
                    peelingSample.updatedUser = dto.updatedUser;
                } else {
                    peelingSample.createdUser = dto.createdUser;
                }
                peelingSamplesInfo.push(peelingSample);
            }
            entity.peelingSamplesInfo = peelingSamplesInfo;
            console.log(entity);
            console.log("testa",dto)
            return entity;
        } catch (error) {
            console.log("err",error)
            return error
        }

    }

    public convertEntityToDto(obj: Peeling): PeelingDto {
        const dto = new PeelingDto;
        dto.peelingId = obj.peelingId;
        dto.saleOrderId = obj.saleOrderId;
        dto.saleOrderItemId = obj.saleOrderItemId;
        dto.lotNumber = obj.lotNumber;
        dto.peelingDate = obj.peelingDate;
        dto.shift = obj.shift;
        dto.isActive = obj.isActive;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        return dto;
    }

    public convertEntityToLabelDto(obj: Peeling): PeelingDto {
        const dto = new PeelingDto;
        dto.peelingId = obj.peelingId;
        dto.saleOrderId = obj.saleOrderId;
        dto.saleOrderItemId = obj.saleOrderItemId;
        dto.lotNumber = obj.lotNumber;
        dto.peelingDate = obj.peelingDate;
        dto.shift = obj.shift;
        dto.isActive = obj.isActive;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        const peelingSamplesInfo: PeelingSamplesDto[] = [];
        for (const iterator of obj.peelingSamplesInfo) {
            const peelingSample = new PeelingSamplesDto();
            peelingSample.peelingId = dto?.peelingId;
                peelingSample.sampleNo = iterator?.sampleNo;
                peelingSample.temperature = iterator?.temperature;
                peelingSample.count = iterator?.count;
                peelingSample.typeOfCut = iterator?.typeOfCut;
                peelingSample.bigToSmallRatio = iterator.bigToSmallRatio;
                peelingSample.legsVeinsShell = iterator.legsVeinsShell;
                peelingSample.improperCutting = iterator.improperCutting;
                peelingSample.blackTailBlackSpot = iterator.blackTailBlackSpot;
                peelingSample.brokenUnstable = iterator.brokenUnstable;
                peelingSample.deteriorationDecomposition = iterator.deteriorationDecomposition;
                peelingSample.otherObjectionableDefects = iterator.otherObjectionableDefects;
                peelingSample.checkedBy = iterator.checkedBy;
                peelingSample.remarks = iterator?.remarks;
                peelingSample.peelingSamplesId = iterator.peelingSamplesId;
                peelingSamplesInfo.push(peelingSample);
            }
        
            dto.peelingSamplesInfo = peelingSamplesInfo;
            console.log(dto);
            return dto;
        } catch (error) {
            return error
        }

}
